import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

// interface IConfirmDeleteMedicalItemPopupProps
// {
//    MedicalItem: MedicalItem;
// }

class ConfirmDeleteMedicalItemPopup extends React.Component<any, any> {
    private id: string = "popupmenu";

    private popupCenteringStyle: React.CSSProperties = {
        left: "50%"
    };

    public render(): JSX.Element {
        return (
            <div id={this.id} className="popup memo" style={this.popupCenteringStyle}>
                <div className="row p-header">
                    <div className="col-lg-12  col-md-12 col-sm-12">
                        <h4> {cacheStore.GetString("RemoveForeverMessageSelected")} </h4>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div key="popupkey">
                            <div className="p-body">
                                <div className="row">
                                    <div className="col-lg-12">
                                        {cacheStore.GetString("DeleteMedicalItem1Label")} {cacheStore.GetString("DeleteAffectationMessage2Label")}
                                    </div>
                                </div>
                            </div>
                            <div className="p-footer">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 columns text-right">
                                        <div>
                                            <div>
                                                <button
                                                    data-action="cancel"
                                                    className="btn btn-default push-right-5"
                                                    onClick={this.CancelClick.bind(this)}
                                                >
                                                    {cacheStore.GetString("CancelLabel")}
                                                </button>
                                                <button
                                                    data-cy="medicalItems-confirm-delete"
                                                    data-action="save"
                                                    className="btn btn-primary push-right-5"
                                                    onClick={this.SaveClick.bind(this)}
                                                >
                                                    {cacheStore.GetString("Ok_Label")}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public componentDidMount(): void {
        var elem = $("#" + this.id);
        var cnt = document.body;
        var dragOptions = {
            handle: ".p-header",
            containment: cnt,
            stop: function() {
                elem.draggable("destroy");
                elem.css({ width: "auto", height: "auto" });
                window.setTimeout(() => elem.draggable(dragOptions), 80);
            }
        };

        elem.draggable(dragOptions);
    }

    private CancelClick(e: React.MouseEvent<HTMLButtonElement>): void {
        e.preventDefault();
        var operation = new LocalEvent(LocalPatientOperations.MedicalItems.CancelRemoveMedicalItem);
        LocalEventDispatcher.dispatch(operation);
        e.preventDefault();
    }

    private SaveClick(e: React.MouseEvent<HTMLButtonElement>): void {
        e.preventDefault();
        var operation = new LocalEvent(LocalPatientOperations.MedicalItems.ConfirmRemoveMedicalItem);
        LocalEventDispatcher.dispatch(operation);
    }
}

export { ConfirmDeleteMedicalItemPopup };
